var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import productItem from "../components/productItem";
import ProductSort from "../entities/ProductSort";
import Order from "../enums/OrderEnum";
import ProductTypeEnum from "../enums/ProductTipeEnum";
import productListView from "../views/productListView";
var products;
export function productListViewLogic(store, mainContent) {
    viewRendering(mainContent);
    products = getProductsFromStore(store);
    renderProductItems(products, mainContent, store);
    populateProductTypesSelectInput();
}
//view rendering
function viewRendering(mainContent) {
    mainContent.innerHTML = productListView();
}
//get products from store
function getProductsFromStore(store) {
    var searchText = window.location.href.split("?")[1];
    if (searchText) {
        var productSearchText = searchText.split("=")[1];
        var searchProducts = store.filterCatalog(productSearchText);
        if (searchProducts.length > 0) {
            return searchProducts;
        }
    }
    return store.showCatalog();
}
//Render products
function renderProductItems(products, mainContent, store) {
    var productContainer = document.getElementById("product-container");
    if (products.length > 0) {
        products.forEach(function (product) {
            productContainer.innerHTML += productItem(product);
        });
    }
    else {
        productContainer.innerHTML = "\n    <div class=\"product-not-found\">\n      <h1>Lo sentimos, no hemos podido encontrar productos con \u00E9ste criterio de b\u00FAsqueda</h1>\n    </div>\n    ";
    }
    filteringProducts(store, mainContent);
}
//Clear products
function clearProductItems() {
    var productContainer = document.getElementById("product-container");
    productContainer.innerHTML = "";
}
//Selector for product types loading
function populateProductTypesSelectInput(initialValue) {
    var typeSelector = document.getElementById("product-type-selector");
    for (var item in Object.values(ProductTypeEnum)) {
        var newOption = document.createElement("option");
        newOption.value = Object.values(ProductTypeEnum)[item];
        if (initialValue == newOption.value) {
            newOption.selected = true;
        }
        newOption.innerHTML = Object.values(ProductTypeEnum)[item];
        typeSelector.appendChild(newOption);
    }
}
//products filtering and ordering
function filteringProducts(store, mainContent) {
    var typeSelector = document.getElementById("product-type-selector");
    var nameOrderSelector = document.getElementById("product-name-order-selector");
    var priceOrderSelector = document.getElementById("product-price-order-selector");
    var filteredProducts = __spreadArray([], products, true);
    typeSelector.addEventListener("change", reRenderFilteredProducts);
    nameOrderSelector.addEventListener("change", reRenderFilteredProducts);
    priceOrderSelector.addEventListener("change", reRenderFilteredProducts);
    function reRenderFilteredProducts() {
        filteredProducts = checkSelectorsStatus(typeSelector, nameOrderSelector, priceOrderSelector, filteredProducts);
        clearProductItems();
        renderProductItems(filteredProducts, mainContent, store);
        typeSelector.removeEventListener("change", reRenderFilteredProducts);
        nameOrderSelector.removeEventListener("change", reRenderFilteredProducts);
        priceOrderSelector.removeEventListener("change", reRenderFilteredProducts);
    }
}
function checkSelectorsStatus(typeSelector, nameOrderSelector, priceOrderSelector, filteredProducts) {
    var sortingMethod = {};
    var sorting;
    if (typeSelector.value != "all") {
        filteredProducts = filteredProducts.filter(function (product) { return product.type == typeSelector.value; });
    }
    if (nameOrderSelector.value == "ASC" ||
        nameOrderSelector.value == "DESC" ||
        priceOrderSelector.value == "ASC" ||
        priceOrderSelector.value == "DESC") {
        nameOrderSelector.value == "ASC"
            ? (sortingMethod.name = Order.ASC)
            : undefined;
        nameOrderSelector.value == "DESC"
            ? (sortingMethod.name = Order.DESC)
            : undefined;
        priceOrderSelector.value == "ASC"
            ? (sortingMethod.price = Order.ASC)
            : undefined;
        priceOrderSelector.value == "DESC"
            ? (sortingMethod.price = Order.DESC)
            : undefined;
        sorting = new ProductSort(filteredProducts);
        sorting.setSorting(sortingMethod);
        filteredProducts = sorting.getSorting();
    }
    return filteredProducts;
}
